<script>
  // One glyph in the active theme's icon set. Call sites import the named
  // wrappers from `lib/icons/` (generated by scripts/generate-icons.mjs) and
  // never this component; the theme registry's `iconSet` decides the drawing.
  import { themeId } from '../stores/theme.js';
  import { getTheme } from '../themes/index.js';
  import { GLYPHS } from '../lib/icons/glyphs.js';

  let { name, size = 24, class: className = '', ...rest } = $props();

  const set = $derived(getTheme($themeId).iconSet === 'pixel' ? 'pixel' : 'iconoir');
</script>

{#if set === 'pixel'}
  <!-- Pixel art is drawn on a 24-cell grid: crisp edges keep the cells square
       at the 14–18px the app mostly uses, instead of blurring them. -->
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24"
    fill="currentColor" shape-rendering="crispEdges" class="icon icon-pixel {className}" {...rest}>
    {#each GLYPHS[name].pixel as [tag, attrs]}<svelte:element this={tag} {...attrs} />{/each}
  </svg>
{:else}
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24"
    fill="none" stroke-width="1.5" class="icon icon-iconoir {className}" {...rest}>
    {#each GLYPHS[name].iconoir as [tag, attrs]}<svelte:element this={tag} {...attrs} />{/each}
  </svg>
{/if}
